module.exports = __webpack_public_path__ + "img/animationPlay.ccc03d46.svg";